import { createFeature, createReducer, on } from '@ngrx/store';
import { EntityServiceError } from '../shared/errors/entity-service.error';
import {
  ResendVerifyEmailEffectActions,
  VerifyEmailPageActions,
} from './resend-verify-email.actions';

interface State {
  error: EntityServiceError;
  submitting: boolean;
  success: boolean;
}

const initialState: State = {
  error: null,
  submitting: false,
  success: false,
};

export const resendVerifyEmailFeature = createFeature({
  name: 'resendVerifyEmail',
  reducer: createReducer(
    initialState,
    on(VerifyEmailPageActions.resendEmailClicked, (state) => ({
      ...state,
      error: null,
      submitting: true,
      success: false,
    })),
    on(ResendVerifyEmailEffectActions.resendEmailSucceeded, (state) => ({
      ...state,
      submitting: false,
      success: true,
    })),
    on(ResendVerifyEmailEffectActions.resendEmailErrored, (state, { error }) => ({
      ...state,
      error,
      submitting: false,
      success: false,
    })),
  ),
});
